import { useQuery } from '@tanstack/react-query';
import type { CourseMapRoot } from '@/components/CourseMap/coursemap.types';
import { supabase } from '@/lib/supabase';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

const EMPTY_MAP: CourseMapRoot = { name: '', id: '', tracker: 'root', children: [] };

export function useAlignmentCourses() {
	return useQuery({
		queryKey: ['get-course-alignment', schoolId],
		queryFn: async () => {
			const { data, error } = await supabase
				.from('course_map')
				.select('course_map_jsonb')
				.eq('isDraft', false)
				.eq('school_id', schoolId)
				.maybeSingle();

			if (error) throw error;
			return (data?.course_map_jsonb as CourseMapRoot | null) ?? EMPTY_MAP;
		},
		staleTime: Infinity,
		refetchOnMount: false,
	});
}
